var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDxcs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 69",
    className: "design-iconfont",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "98.993048%",
    id: "1wd3rgruoc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88E51",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4519",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "nsc307d0sb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD7C",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF795B",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "15.0784394%",
    y1: "25.2220072%",
    x2: "91.088602%",
    y2: "76.6881963%",
    id: "x4896dqebd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9E1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE9E1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-44%",
    y: "-37%",
    width: "187.9%",
    height: "173.9%",
    filterUnits: "objectBoundingBox",
    id: "jyw0na1p7a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.329116928 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#jyw0na1p7a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29,6 C35.3506307,6 41.0997889,8.58913593 45.2614593,12.7744092 C49.4251707,16.9617352 52,22.7466044 52,29.1361163 C52,34.6616494 48.5782888,41.4412816 44.3475291,47.410863 C38.7842583,55.2606113 31.7296255,62 29,62 C26.2703745,62 19.2157417,55.2606113 13.6524709,47.410863 C9.42171119,41.4412816 6,34.6616494 6,29.1361163 C6,22.7466044 8.57482926,16.9617352 12.7385407,12.7744092 C16.9002111,8.58913593 22.6493693,6 29,6 Z",
    stroke: "url(#nsc307d0sb)",
    strokeWidth: 2,
    fill: "url(#1wd3rgruoc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64332534,12.2698134 L1.62044562,12.2698134 C0.72516005,12.2698134 0,11.6619441 0,10.9114662 L0,9.16451039 C0,8.41403244 0.72516005,7.80616314 1.62044562,7.80616314 L2.6326925,7.80616314 C3.09628455,5.22316423 4.5572375,3.15355641 7.0729687,1.63833966 C8.92946349,0.520644486 11.0283871,0.0108186149 13.303816,0.000122967269 C17.7972565,-0.021268328 23.0158569,2.74890441 23.8409657,7.79903271 L24.9978193,7.79903271 C25.8931049,7.79903271 26.6182649,8.40690201 26.6182649,9.15737996 L26.6182649,10.8936401 C26.6182649,11.644118 25.8931049,12.2519873 24.9978193,12.2519873 L23.9855724,12.2519873 C23.5751446,15.2128991 23.1689699,18.1524196 22.7606687,21.1044184 C22.6662981,21.7899259 21.9740618,22.3073404 21.1508559,22.3076878 L5.41424483,22.3076878 C4.58700946,22.3094613 3.89374795,21.7871572 3.80230548,21.0972879 C3.41526991,18.1542022 3.03036091,15.2235948 2.64332534,12.2698134 Z M20.7030949,8.26210492 C20.2757329,5.29856736 17.2901896,2.42752474 13.2322472,2.4793219 C9.00855226,2.53296896 6.29260656,5.54830367 5.91516999,8.26210492 L20.7030949,8.26210492 L20.7030949,8.26210492 Z M9.85861664,19.0028413 L9.85861664,13.2193679 L6.90103165,13.2193679 L6.90103165,19.0028413 L9.85861664,19.0028413 Z M19.7172333,13.2193679 L16.7596483,13.2193679 L16.7596483,19.0028413 L19.7172333,19.0028413 L19.7172333,13.2193679 Z",
    transform: "translate(16.090944 18.384615)",
    fill: "url(#x4896dqebd)",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDxcs);
export default __webpack_public_path__ + "static/media/dxcs.c00f1fb5c551dbb86382c6599983eb0b.svg";
export { ForwardRef as ReactComponent };